export default "__VITE_ASSET__D6wvQ3Ya__"